// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/global-theme.css'
import './assets/css/mobile.css'
import App from './App'
import router from './router'
import axios from 'axios'
import {post,fetch,patch,put} from './assets/js/http.js'
import CommonBody from './components/common-body/common-body.vue'
import LqRemarksCell from './components/LqRemarksCell/index.vue'
import Print from 'vue-print-nb'
// import Print from './utils/print'

import './utils/flexible'

Vue.use(Print);
Vue.use(ElementUI);
Vue.component('common-body', CommonBody)
Vue.component('lq-remarks-cell', LqRemarksCell)
Vue.config.productionTip = false

//定义全局变量
Vue.prototype.$post=post;
Vue.prototype.$fetch=fetch;
Vue.prototype.$patch=patch;
Vue.prototype.$put=put;


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
